/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createKnotSession} from '../api'

export const useMutationCreateKnotSession = createReactQueryMutationHook('createKnotSession', createKnotSession)
